export class UserFilesApi {
  constructor(private readonly _baseUrl: string) {}

  public crud(): string {
    return `${this._baseUrl}/`;
  }
}
